import { render, staticRenderFns } from "./move_list.vue?vue&type=template&id=67836a4f&scoped=true&"
import script from "./move_list.vue?vue&type=script&lang=js&"
export * from "./move_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67836a4f",
  null
  
)

export default component.exports